module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/_iterators.js
// module id = 45
// module chunks = 0